import { useAddToCart, useUpdateCartItem, useCart, useRemoveCartItem } from 'src/services/api/queries/queries'
import { Product } from 'src/types/types'

interface WastePortalProductActions {
    addToCart: (onSuccess?: () => void, onError?: () => void) => void
    subtractFromCart: (onSuccess?: () => void, onError?: () => void) => void
    removeFromCart: (onSuccess?: () => void, onError?: () => void) => void
    isLoading: boolean
    count: number
}

export const useWastePortalActions = (product: Product): WastePortalProductActions => {
  const addToCartMutation = useAddToCart()
  const removeFromCartMutation = useRemoveCartItem()
  const updateCartItemMutation = useUpdateCartItem()
  const { data: cartData } = useCart()

  const cartKey = cartData?.items.find((item) => item.id === product?.id)?.key
  const productQuantity = cartData?.items.find((item) => item.id === product?.id)?.quantity

  const handleAddToCart = (onSuccess?: () => void, onError?: () => void) => {
    if (product?.id) {
        console.log('Adding product ID: ', product.id)
      addToCartMutation.mutate(
        { productId: product.id, quantity: 1 },
        {
          onSuccess: () => {
            onSuccess?.()
          },
          onError: () => {
            onError?.()
          },
        }
      )
      product?.cross_sell_ids?.forEach((cross_sell_id) => {
        console.log('Adding linked product ID: ', cross_sell_id)
          addToCartMutation.mutate(
              { productId: cross_sell_id, quantity: 1 },
              {
              onSuccess: () => {
                  onSuccess?.()
              },
              onError: () => {
                  onError?.()
              },
          })
      })
    }
  }

  const handleSubtractFromCart = (onSuccess?: () => void, onError?: () => void) => {
    if (cartKey) {
      updateCartItemMutation.mutate(
        { key: cartKey, quantity: 1 }, {
          onSuccess: () => {
            onSuccess?.()
          },
          onError: () => {
            onError?.()
          },
        }
      )
    }
  }

  const handleRemoveFromCart = (onSuccess?: () => void, onError?: () => void) => {
    if (cartKey) {
      removeFromCartMutation.mutate(cartKey, {
        onSuccess: () => {
          onSuccess?.()
        },
        onError: () => {
          onError?.()
        },
      })
    }
  }

  return {
    addToCart: handleAddToCart,
    subtractFromCart: handleSubtractFromCart,
    removeFromCart: handleRemoveFromCart,
    isLoading: addToCartMutation.isLoading || removeFromCartMutation.isLoading,
    count: productQuantity,
  }
}
